export const SCORES_BAR = {
  ACTION_TYPES: {
    onTabChange: 'onTabChange',
    onLiveClick: 'onLiveClick',
    onDateChange: 'onDateChange',
    onMyScoresPageChange: 'onMyScoresPageChange',
    onDateArrowClick: 'onDateArrowClick',
    onDropdownFilterChange: 'onDropdownFilterChange',
    statePopulation: 'statePopulation',
    calendarClick: 'calendarClick'
  },

  SCORES_INDEXES: {
    allScores: 0,
    competitionScores: 1,
    competitorScores: 2,
    myScores: 3,
    athlete: 4
  },

  DIRECTIONS: {
    prev: 'prev',
    next: 'next'
  },

  ANALYTICS: {
    ARROW_CLICK_TYPE: {
      arrows: 'arrows',
      calendar: 'calendar'
    },
  },

  dayToFetch: 2,
  recentlyEndedViewHours: 12
};

export const SCORES_BAR_SOURCES = {
  [SCORES_BAR.SCORES_INDEXES.allScores]: 'all-scores',
  [SCORES_BAR.SCORES_INDEXES.myScores]: 'my-scores',
  [SCORES_BAR.SCORES_INDEXES.competitionScores]: 'competition-scores',
  [SCORES_BAR.SCORES_INDEXES.competitorScores]: 'competitor-scores',
};
